import { motion } from 'framer-motion';
import { Link } from 'wouter';
import { Utensils } from 'lucide-react';

export function FloatingRestaurantButton() {
  return (
    <motion.div 
      className="fixed bottom-24 right-6 z-50"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
    >
      <Link href="/restaurant">
        <motion.a
          className="relative bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg shadow-xl transition-all duration-300 flex items-center gap-2 font-medium text-base cursor-pointer"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Utensils className="w-5 h-5" />
          <span>
            Restaurant Orders
          </span>
          <span className="text-xl">→</span>
        </motion.a>
      </Link>
    </motion.div>
  );
}